import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { CompetencyTypesService } from 'app/_services/competency-types.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-competency-types',
  templateUrl: './competency-types.component.html',
})
export class CompetencyTypesComponent implements OnInit {
  competencyTypes: any[];
  selectedCompetencyType: any = [];

  errorAlerts;

  // pagination
  pageSizes: any = environment.pageSizes;
  pagination: any;

  createCompetencyTypeModal = false;
  createCompetencyTypeForm: FormGroup;

  typeOptions = [
    { display: 'Select Type...', value: null },
    { display: 'General Site', value: 'GENERAL_SITE' },
    { display: 'Contractor', value: 'POWERSTATION' },
    { display: 'Turbine', value: 'TURBINE' },
  ];

  editCompetencyTypeModal = false;
  editCompetencyTypeForm: FormGroup;

  allWorkerRequired: boolean;

  constructor(
    public fb: FormBuilder,
    public competencyTypeService: CompetencyTypesService
  ) {

    this.createCompetencyTypeForm = fb.group({
      value: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      allWorkerRequired: new FormControl (false)
    });

    this.editCompetencyTypeForm = fb.group({
      value: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      allWorkerRequired: new FormControl (false)
    });

    this.resetPagination();
  }

  ngOnInit() {
    this.getAllCompetencyTypes();
  }

  public getAllCompetencyTypes() {
    this.competencyTypeService.getAllCompetencyTypes(this.pagination).subscribe((data: any) => {
      this.competencyTypes = data.body;
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public toggleCreateCompetencyTypeModal() {
    this.createCompetencyTypeModal = !this.createCompetencyTypeModal;
  }

  public onCreateCompetencyTypeFormSubmit() {
    const values = this.createCompetencyTypeForm.value;
    const body = {
      value: values.value,
      type: values.type.value,
      allWorkerRequired: values.allWorkerRequired
    };
    this.competencyTypeService.createCompetencyType(body).subscribe((data: any) => {
      this.createCompetencyTypeForm.reset();
      this.toggleCreateCompetencyTypeModal();
      this.getAllCompetencyTypes();
      Swal.fire('Success', 'Competency Type Created!', 'success');
    });
  }

  public editTypeSetup() {
    const selectedType = this.typeOptions.find((option) => option.value === this.selectedCompetencyType.type);
    this.editCompetencyTypeForm.patchValue({
      value: this.selectedCompetencyType.value,
      type: selectedType,
      allWorkerRequired: this.selectedCompetencyType.allWorkerRequired
    });
    this.toggleEditCompetencyTypeModal();
  }

  // Handle onRowSelect of a user
  public async onRowSelect(event) {
    this.selectedCompetencyType = event.data;
    const { value: action } = await Swal.fire({
      titleText: event.data.value,
      input: 'select',
      inputOptions: {
        edit: 'Edit',
        delete: 'Delete',
      },
      inputPlaceholder: 'Select an option',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          resolve(null);
        });
      },
    });

    if (action) {
      if (action === 'edit') {
        this.editTypeSetup();
      } else if (action === 'delete') {
        this.deleteType();
      } else {
        console.log('No valid option selected');
      }
    }
  }

  public toggleEditCompetencyTypeModal() {
    this.editCompetencyTypeModal = !this.editCompetencyTypeModal;
  }

  public onEditCompetencyTypeFormSubmit() {
    const values = this.editCompetencyTypeForm.value;
    const body = {
      value: values.value,
      id: this.selectedCompetencyType.id,
      type: values.type.value,
      allWorkerRequired: values.allWorkerRequired
    };
    this.competencyTypeService.editCompetencyType(body).subscribe((data: any) => {
      this.editCompetencyTypeForm.reset();
      this.toggleEditCompetencyTypeModal();
      this.getAllCompetencyTypes();
      Swal.fire('Success', 'Competency Type Updated!', 'success');
    });
  }

  public deleteType() {
    this.competencyTypeService.deleteCompetency(this.selectedCompetencyType.id).subscribe((data: any) => {
      this.getAllCompetencyTypes();
      Swal.fire('Success', 'Competency Type Deleted!', 'success');
    });
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.getAllCompetencyTypes();
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllCompetencyTypes();
  }
  /* PAGINATION END */
}
